module.exports = __webpack_public_path__ + "static/img/shiyuflames.6ba8e55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conversion/testimonial/shiyuflames.png
// module id = lgrK
// module chunks = 35